module.exports = __webpack_public_path__ + "media/images/lb/331-102275b011f5224be2930f73ef290206.svg";